import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'onOff'
})
export class OnOffPipe implements PipeTransform {

  transform(value: any): any {
    return value ? 'On' : 'Off';
  }

}
